import { Check, AlertCircle, Mail } from 'lucide-react';
import { Alert, AlertDescription } from '../ui/alert';
import type { SendStatus, EmailSendTranslations } from './types';

interface StatusMessagesProps {
  sendStatus: SendStatus;
  t: EmailSendTranslations;
}

export function StatusMessages({ sendStatus, t }: StatusMessagesProps) {
  return (
    <>
      {sendStatus === 'success' && (
        <Alert className="bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800">
          <Check className="w-4 h-4 text-green-600 dark:text-green-400" />
          <AlertDescription className="text-green-800 dark:text-green-200">
            {t.success}
          </AlertDescription>
        </Alert>
      )}

      {sendStatus === 'error' && (
        <Alert className="bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800">
          <AlertCircle className="w-4 h-4 text-red-600 dark:text-red-400" />
          <AlertDescription className="text-red-800 dark:text-red-200">
            {t.error}
          </AlertDescription>
        </Alert>
      )}

      <div className="flex items-start gap-2 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-800">
        <Mail className="w-5 h-5 text-blue-600 dark:text-blue-400 mt-0.5 shrink-0" />
        <p className="text-sm text-blue-800 dark:text-blue-200">
          {t.filesIncluded}
        </p>
      </div>
    </>
  );
}
